import { useState } from 'react';
import { CreateAccountModal, useAuth } from './_barrel.js';


        // =======================================================================
        // Login screen
        // =======================================================================
        function LoginScreen() {
            const { loginWithEmail, loading, error } = useAuth();
            const [showSignup, setShowSignup] = useState(false);
            const [email, setEmail] = useState('');
            const [emailErr, setEmailErr] = useState(null);
            const [busy, setBusy] = useState(false);
            const submitEmail = async () => {
                setBusy(true); setEmailErr(null);
                const res = await loginWithEmail(email);
                if (res === 'invalid') { setEmailErr('Please enter a valid email address.'); setBusy(false); }
                else if (res === 'no-account') { setEmailErr('No account found for that email. Check it, or ask your administrator.'); setBusy(false); }
                else if (res === 'network') { setEmailErr('Could not reach the server. Please try again.'); setBusy(false); }
                else if (res === 'not-ready') { setEmailErr('Still loading — try again in a moment.'); setBusy(false); }
                // on success (res === null) the browser redirects to Auth0; stay busy.
            };
            return (
                <div className="min-h-screen flex flex-col items-center justify-center px-6"
                     style={{
                         backgroundImage: "linear-gradient(rgba(8,12,19,0.88), rgba(8,12,19,0.94)), url('/login-bg.jpg')",
                         backgroundSize: 'cover',
                         backgroundPosition: 'center',
                     }}>
                    <div className="text-center">
                        <div className="flex items-center justify-center mb-8">
                            <div className="h-px w-12 bg-[var(--gold-dim)]"></div>
                            <span className="crest-mark"></span>
                            <div className="h-px w-12 bg-[var(--gold-dim)]"></div>
                        </div>
                        <h1 className="font-display text-6xl tracking-wide gold mb-2">OBSIDIAN VEIL</h1>
                        <div className="font-mono text-xs uppercase tracking-[0.12em] text-muted mb-12">
                            Protective Intelligence Platform
                        </div>
                        <div className="text-muted text-sm max-w-sm mx-auto mb-12 leading-relaxed">
                            Vulnerability, Exposure, Impersonation, Lifecycle.
                            <br />
                            Sign in with the email address you signed up with.
                        </div>
                        {error && (
                            <div className="text-[var(--red)] text-sm mb-6">{error}</div>
                        )}
                        <div className="max-w-sm mx-auto">
                            <input
                                type="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                onKeyDown={e => { if (e.key === 'Enter' && !busy) submitEmail(); }}
                                placeholder="you@example.com"
                                autoFocus
                                autoComplete="email"
                                style={{width:'100%', background:'var(--zone-2)', color:'var(--text)', border:'1px solid var(--veil)', padding:'12px 14px', fontSize:'14px', textAlign:'center', letterSpacing:'0.02em', marginBottom:'12px'}}
                            />
                            {emailErr && (
                                <div className="text-[var(--red)] text-sm mb-4">{emailErr}</div>
                            )}
                            <button className="btn-gold" style={{width:'100%'}} onClick={submitEmail} disabled={loading || busy}>
                                {busy ? 'Continuing…' : (loading ? 'Initialising…' : 'Continue')}
                            </button>
                            <div className="mt-6">
                                <button
                                    className="btn-gold"
                                    style={{background: 'transparent', color: 'var(--cyan)', border: '1px solid var(--cyan-dim)'}}
                                    onClick={() => setShowSignup(true)}
                                    disabled={loading}
                                >
                                    Create Account
                                </button>
                            </div>
                        </div>
                        <div className="text-dim text-xs mt-6">
                            New tenants are reviewed by our team before activation.
                        </div>
                    </div>
                    <div className="absolute bottom-6 text-dim text-xs font-mono">
                        Obsidian Arc Ltd · 6th Floor, 37 Lombard Street, London EC3V 9BQ
                    </div>
                    {showSignup && <CreateAccountModal onClose={() => setShowSignup(false)} />}
                </div>
            );
        }

export { LoginScreen };
